import React,{ useState } from "react";
import Contact from "./components/contact/Contact";
import Intro from "./components/intro/Intro";
import Aboutme from "./components/aboutme/Aboutme";
import Education from "./components/education/Education";
import Topbar from "./components/topbar/Topbar";
import  Work  from "./components/work/Work";
import Menu from "./components/menu/Menu";
import "./app.scss"
function App() {
  const [menuOpen,setMenuOpen]=useState(false)
  return (
    <div className="app">
<Topbar menuOpen={menuOpen} setMenuOpen={setMenuOpen}/>
<Menu menuOpen={menuOpen} setMenuOpen={setMenuOpen}/>
<div className="sections">
  <Intro/>
  <Work/>
 <Education/>
  <Aboutme/>
  <Contact/>

</div>

</div>
  );
}

export default App;
